( function () {
   
    'use strict';
  
    ( function ( $ ) {
       if(window.innerWidth <= 1350){
        var swiper = new Swiper(".product-list-Swiper", {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                640: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                  destroy: false,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                  destroy: false,
                },
                1061: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                  destroy: false,
                },
                1350: {
                  slidesPerView: "auto",
                  spaceBetween: 30, 
                  destroy: true,
                  loop: false,
                },
              },
          });
       }
       

        //   function initializeSwiper() {
        //     const isMobile = window.innerWidth <= 768;
        //     const swiper = new Swiper('.product-list-Swiper', {
        //       slidesPerView: isMobile ? 1 : 'auto',
        //       spaceBetween: isMobile ? 10 : 30,
        //       navigation: isMobile ? false : {
        //         nextEl: '.swiper-button-next',
        //         prevEl: '.swiper-button-prev',
        //       },
        //     });
        //   }
      
          // Initialize Swiper on page load
        //   document.addEventListener('DOMContentLoaded', function () {
        //     initializeSwiper();
        //   });
      
        //   // Reinitialize Swiper on window resize
        //   window.addEventListener('resize', function () {
        //     document.querySelector('.swiper-container').swiper.destroy();
        //     initializeSwiper();
        //   });
} )( jQuery );
} )();